import styled from '@emotion/styled'

import { Image } from '@core/components/Image'

export const AudioVisualizerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const AudioVisualizerText = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 102px;
  color: var(--white);
  position: absolute;
  z-index: 1;
`

export const AudioVisualizerImage = styled(Image)<{ size: number }>`
  border-radius: 50%;
  position: absolute;
  object-fit: cover;
  object-position: top;
  z-index: 1;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
`

export const AudioVisualizerTextWrapper = styled.div<{
  size: number
  showDefaultAnimation: boolean
}>`
  background-color: var(--gray3);
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  ${({ showDefaultAnimation }) =>
    showDefaultAnimation
      ? `
      animation-name: pulse;
      animation-duration: 2s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;

      @keyframes pulse {
        0% {
          transform: scale(1);
          opacity: 0.7;
        }

        50% {
          transform: scale(1.2);
          opacity: 1;
        }

        100% {
          transform: scale(1);
          opacity: 0.7;
        }
      } 
  `
      : 'transition: transform 0.2s steps(6, jump-none) 33.33ms;'}
`
